var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01477 3.03606C8.89593 1.50361 11.1069 1.5036 11.9881 3.03605L18.6905 14.6925C19.569 16.2203 18.4662 18.1265 16.7039 18.1265H3.29898C1.53665 18.1265 0.433848 16.2203 1.31232 14.6925L8.01477 3.03606ZM10.9045 3.65914C10.5039 2.96258 9.49893 2.96258 9.09841 3.65915L2.39595 15.3156C1.99665 16.01 2.49792 16.8765 3.29898 16.8765H16.7039C17.5049 16.8765 18.0062 16.01 17.6069 15.3156L10.9045 3.65914Z",
    fill: "#D07200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0014 6.8765C10.3466 6.8765 10.6264 7.15632 10.6264 7.5015V10.8348C10.6264 11.18 10.3466 11.4598 10.0014 11.4598C9.65625 11.4598 9.37643 11.18 9.37643 10.8348V7.5015C9.37643 7.15632 9.65625 6.8765 10.0014 6.8765Z",
    fill: "#D07200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4279 13.7027C10.6844 13.9336 10.7052 14.3288 10.4743 14.5853L10.466 14.5946C10.2351 14.8512 9.8399 14.872 9.58333 14.6411C9.32676 14.4101 9.30596 14.015 9.53687 13.7584L9.54521 13.7491C9.77612 13.4926 10.1713 13.4718 10.4279 13.7027Z",
    fill: "#D07200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning_triangle.bacdf8ae02142f541a406d76428d2dc4.svg";
export { ForwardRef as ReactComponent };